import {
  EFFECTS_DESCRIPTOR_DAMAGE_REQUEST,
  EFFECTS_DESCRIPTOR_HOUSES_REQUEST,
  EFFECTS_DESCRIPTOR_PEOPLE_REQUEST,
} from './effectDescriptorReducer';

export const getPeople = () => ({ type: EFFECTS_DESCRIPTOR_PEOPLE_REQUEST });
export const getHouses = () => ({ type: EFFECTS_DESCRIPTOR_HOUSES_REQUEST });
export const getDamage = () => ({ type: EFFECTS_DESCRIPTOR_DAMAGE_REQUEST });
